import { render, staticRenderFns } from "./SelectionCardCheckbox.vue?vue&type=template&id=a32951f0&"
import script from "./SelectionCardCheckbox.vue?vue&type=script&lang=ts&"
export * from "./SelectionCardCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports